<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="来料入库" name="first">来料入库</el-tab-pane>
      <el-tab-pane label="领料出库" name="second">领料出库</el-tab-pane>
      <el-tab-pane label="成品入库" name="third">成品入库</el-tab-pane>
    </el-tabs>

  <el-form :model="form"  label-position="right" ref="refForm" :rules="rules" label-width="130px">
    <el-form-item v-if="activeName == 'first'" label="订单信息" prop="order">
      <el-input v-model="form.order" style="width: 250px;" readonly placeholder="请选择订单" @click.native="incoOrderAction">请选择订单号</el-input>
    </el-form-item>
    <el-form-item label="箱子信息" prop="boxNo">
      <el-input v-model="form.boxNo" ref="inputRef" placeholder="扫码/输入箱子Tracking NO" style="width: 250px;" maxlength="64"></el-input>
    </el-form-item>
    <el-form-item  v-if="activeName == 'first'" label="箱子数量" prop="boxCount">
      <el-input v-model="form.boxCount" ref="inputCountRef" placeholder="扫码/输入箱子芯片数量" style="width: 250px;"></el-input>
    </el-form-item>
    <el-form-item  v-if="activeName != 'second'" label="库位" prop="storePosition">
      <el-input v-model="form.storePosition" ref="inputPositionRef" placeholder="扫码/输入库位号" style="width: 250px;"></el-input>
    </el-form-item>
  </el-form>
    <div style="margin-top: 20px;"><el-button type="primary" :loading="loading" @click.native="btnClick">确定</el-button></div>
    <div style="margin-top: 20px;"><el-button style="font-size: 12px;" type="text" @click.native="appListAction">历史记录</el-button></div>


  <el-dialog width="90%" title="请选择订单" :visible.sync="outerVisible">
    <div style="display: flex;justify-content: space-between;flex-direction: row;margin-top: -20px;">
      <el-input v-model="orderNo" style="width: 200px;" placeholder="请输入内容"></el-input>
      <el-button size="mini" type="primary" @click.native="searchAction" >搜索</el-button>
    </div>
    <ul class="infinite-list" style="overflow:auto;color:#333333;width:100%;margin-top: 10px;">
      <li v-for="(i, index) in data" :key="index" class="infinite-list-item" @click="orderAction(index)">
          <div>
            <div >订单号: {{i.incoOrderNo}}</div>
            <div >客户名称: {{i.customer.customerName}}</div>
            <div >下单时间: {{formatDate(i.orderDate)}}</div>
          </div>
          <hr />
      </li>
    </ul>
    <button v-if="data.length" style="width: 100%;height: 40px;background-color: #FFFFFF;" @click="getMorelist()">加载更多</button>
      <el-dialog
        width="90%"
        title="请选择产品型号和印章号"
        :visible.sync="innerVisible"
        append-to-body>
        <ul class="infinite-list" style="overflow:auto;color:#333333;width:100%;">
          <li v-for="(i, index) in data1" :key="index" class="infinite-list-item" @click="productAction(index)">
              <div>
                <div >产品型号/芯片名称: {{i.product.productName}}/{{i.product.chipName}}</div>
                <div >印章号: {{i.lotNo}}</div>
                <div >子批号: {{i.subNo}}</div>
                <div >加工方式: {{i.processType == 1 ? '测试' : '测编'}}</div>
              </div>
              <hr />
          </li>
        </ul>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
      </div>
    </el-dialog>


  </div>



</template>

<script>
import { incoStorageEntry, incoStorageDelivery } from '@/api/incoStorage';
import { productsEntry } from '@/api/prodStorage';
import { incoOrderList } from '@/api/incoOrder';
import moment from 'moment';
	import { isPositiveIntegerNum,isValueEmpty } from '@/utils';

export default {

  data() {
    let validateOrder = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value.trim() === '';
        if (isEmptyValue) {
            callback(new Error('订单不能为空'));
            return;
        }
        callback();
    };
    let validateBoxNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value.trim() === '';
        if (isEmptyValue) {
            callback(new Error('箱号不能为空'));
            return;
        }
        callback();
    };
    let validateCount = (rule, value, callback) => {
    	if (isValueEmpty(value)) {
    		callback(new Error('数量不能为空'));
    		return;
    	}
    	if (!isPositiveIntegerNum(value)) {
    		callback(new Error('数量必须为大于等于1小于等于1000000的正整数'));
    		return;
    	}
    	if (parseInt(value) < 1 || parseInt(value) > 1000000) {
    		callback(new Error('数量必须为大于等于1小于等于1000000的正整数'));
    		return;
    	}
    	callback();
    };
    let validateStorePosition = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value.trim() === '';
        if (isEmptyValue) {
            callback(new Error('库位不能为空'));
            return;
        }
        callback();
    };
    return {
      rules: {
      	order: [{required: true, validator: validateOrder, trigger:  ['blur', 'change']}],
      	boxNo: [{required: true, validator: validateBoxNo, trigger: 'blur'}],
      	boxCount: [{required: true, validator: validateCount, trigger: 'blur'}],
      	storePosition: [{required: true, validator: validateStorePosition, trigger: 'blur'}],
      },
      form: {
        order: '',
      	boxNo: '',
      	boxCount: '',
      	storePosition: '',
      },
      activeName: 'first',
      boxNo: '',
      storePosition: '',
      count: 10,
      loading: false,
      data: [],
      data1: [],
      index:0,
      index1:0,
      outerVisible: false,
      innerVisible: false,
      order:'',
      incoOrdersDetails:'',
      boxCount:'',
      page:1,
      orderNo:'',
    };
  },
  mounted() {
    !this.incoOrdersDetails ? this.$refs.inputRef.blur() : this.$refs.inputRef.focus();
    this.scanBoxInfoBarCode();
  },
  methods: {
    handleClick() {
      this.form.boxNo = '';
      this.form.boxCount = '';
      this.form.storePosition = '';
      !this.incoOrdersDetails ? this.$refs.inputRef.blur() : this.$refs.inputRef.focus();
    },
    btnClick() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          if (this.activeName === 'first') {
            this.entryPost();
          } else if (this.activeName === 'second') {
            this.deliveryPut();
          } else {
            this.productsEntry();
          }
        }
      });

    },
    appListAction() {
      this.loading = false;
      this.$router.push({
        name: 'AppList',
        params: { activeName: this.activeName },
      });
    },
    incoOrderAction() {
      this.outerVisible = true;
      this.orderNo = '';
      this.page = 1 ;
      this.incoStorageOprList();
    },
    orderAction(index){
      this.index = index;
      this.data1 = this.data[index].incoOrdersDetails;
      this.innerVisible = true;

    },
    productAction(index){
      this.innerVisible = false;
      this.outerVisible = false;
      this.index1 = index;
      this.incoOrdersDetails = this.data1[index];
      this.form.order = this.data1[index].subNo;
      this.$refs.inputRef.focus();

    },
    async entryPost() {
      try {
        await incoStorageEntry({
          boxNo: this.form.boxNo,
          storePosition: this.form.storePosition,
          incoOrderNo:this.data[this.index].incoOrderNo,
          productId:this.data[this.index].incoOrdersDetails[this.index1].productId,
          lotNo:this.data[this.index].incoOrdersDetails[this.index1].lotNo,
          processType:this.data[this.index].incoOrdersDetails[this.index1].processType,
          count:this.form.boxCount,
          comment:'',
          cases:[],
        });
        this.form.boxNo = '';
        this.form.boxCount = '';
        this.form.storePosition = '';
        this.$message({
          type: 'success',
          message: '成功',
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async deliveryPut() {
      try {
        await incoStorageDelivery({
          boxNo: this.form.boxNo,
        });
        this.form.boxNo = '';
        this.form.storePosition = '';
        this.$message({
          type: 'success',
          message: '成功',
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async productsEntry() {
      try {
        await productsEntry({
          boxNo: this.form.boxNo,
          storePosition: this.form.storePosition,
        });
        this.form.boxNo = '';
        this.form.storePosition = '';
        this.$message({
          type: 'success',
          message: '成功',
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    getMorelist(){
      this.page++;
      this.incoStorageOprList();
    },
    searchAction(){
      this.page = 1 ;
      this.incoStorageOprList();
    },
    async incoStorageOprList() {
      try {
        if (this.orderNo) {
          const res = await incoOrderList({
            page: this.page,
            perpage: 10,
            incoOrderNo: this.orderNo,
            hasNotReceivedBox:true,
          });
          if(this.page != 1){
            this.data=this.data.concat(res.data.records)
          }else{
            this.data = res.data.records;
          }
        } else{
          const res = await incoOrderList({
            page: this.page,
            perpage: 10,
            hasNotReceivedBox:true,
          });
          if(this.page != 1){
            this.data=this.data.concat(res.data.records)
          }else{
            this.data = res.data.records;
          }
        }
      } catch (e) {
        // do nothing.
      }
    },
    scanBoxInfoBarCode() {
      let code = '';
      let nextCode;
      document.onkeypress = (e) => {
        nextCode = e.which;
        if (nextCode !== 13) {
          code += String.fromCharCode(nextCode);
        }
        if (nextCode === 13) {
          if (this.activeName === 'first') {
            if (!this.form.order) {

            }
            if (this.form.boxNo) {
              this.$refs.inputCountRef.focus();
            }
            if (this.form.boxCount) {
              this.$refs.inputPositionRef.focus();
            }
            if (this.form.storePosition) {
              this.$refs.inputRef.focus();
            }
            if (this.form.boxNo && this.form.storePosition && this.form.boxCount) {
              this.entryPost();
            }
          } else if (this.activeName === 'second') {
            if (this.form.boxNo) {
              this.$refs.inputRef.focus();
              this.deliveryPut();
            }
          } else {
            if (this.form.boxNo) {
              this.$refs.inputPositionRef.focus();
            }
            if (this.form.storePosition) {
              this.$refs.inputRef.focus();
            }
            if (this.form.boxNo && this.form.storePosition) {
              this.productsEntry();
            }
          }
        }
      };
    },
    formatDate(date) {
        const updateDate = moment.utc(date);
        return updateDate.local().format('YYYY-MM-DD');
    },
  },
};
</script>

<style lang="less" scoped>
  .container {
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
    .login-container {
      position: relative;
      width: 300px;
      max-width: 100%;
      padding: 30px;
      margin: auto;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }
  }
</style>
